export interface CountryModel {
  countryCode: string;
  countryName: string;
  dialCode: string;
  digitCount: number;
  flag: string;
  format: string;
  example: string;
}

export class CountryData {
  static readonly countries: CountryModel[] = [
    {
      countryCode: 'IN',
      countryName: 'India',
      dialCode: '+91',
      digitCount: 10,
      flag: '🇮🇳',
      format: '+91 XXXXX XXXXX',
      example: '+91 98765 43210'
    },
    {
      countryCode: 'US',
      countryName: 'United States',
      dialCode: '+1',
      digitCount: 10,
      flag: '🇺🇸',
      format: '+1 XXX XXX XXXX',
      example: '+1 555 123 4567'
    },
    {
      countryCode: 'GB',
      countryName: 'United Kingdom',
      dialCode: '+44',
      digitCount: 10,
      flag: '🇬🇧',
      format: '+44 XXXX XXXXXX',
      example: '+44 7700 900123'
    },
    {
      countryCode: 'CA',
      countryName: 'Canada',
      dialCode: '+1',
      digitCount: 10,
      flag: '🇨🇦',
      format: '+1 XXX XXX XXXX',
      example: '+1 416 555 0123'
    },
    {
      countryCode: 'AU',
      countryName: 'Australia',
      dialCode: '+61',
      digitCount: 9,
      flag: '🇦🇺',
      format: '+61 XXX XXX XXX',
      example: '+61 412 345 678'
    },
    {
      countryCode: 'DE',
      countryName: 'Germany',
      dialCode: '+49',
      digitCount: 11,
      flag: '🇩🇪',
      format: '+49 XXX XXXXXXXX',
      example: '+49 151 12345678'
    },
    {
      countryCode: 'FR',
      countryName: 'France',
      dialCode: '+33',
      digitCount: 9,
      flag: '🇫🇷',
      format: '+33 X XX XX XX XX',
      example: '+33 6 12 34 56 78'
    },
    {
      countryCode: 'JP',
      countryName: 'Japan',
      dialCode: '+81',
      digitCount: 10,
      flag: '🇯🇵',
      format: '+81 XX XXXX XXXX',
      example: '+81 90 1234 5678'
    },
    {
      countryCode: 'CN',
      countryName: 'China',
      dialCode: '+86',
      digitCount: 11,
      flag: '🇨🇳',
      format: '+86 XXX XXXX XXXX',
      example: '+86 138 0013 8000'
    },
    {
      countryCode: 'BR',
      countryName: 'Brazil',
      dialCode: '+55',
      digitCount: 11,
      flag: '🇧🇷',
      format: '+55 XX XXXXX XXXX',
      example: '+55 11 99999 9999'
    },
    {
      countryCode: 'MX',
      countryName: 'Mexico',
      dialCode: '+52',
      digitCount: 10,
      flag: '🇲🇽',
      format: '+52 XXX XXX XXXX',
      example: '+52 55 1234 5678'
    },
    {
      countryCode: 'RU',
      countryName: 'Russia',
      dialCode: '+7',
      digitCount: 10,
      flag: '🇷🇺',
      format: '+7 XXX XXX XX XX',
      example: '+7 912 345 67 89'
    },
    {
      countryCode: 'IT',
      countryName: 'Italy',
      dialCode: '+39',
      digitCount: 10,
      flag: '🇮🇹',
      format: '+39 XXX XXX XXXX',
      example: '+39 320 123 4567'
    },
    {
      countryCode: 'ES',
      countryName: 'Spain',
      dialCode: '+34',
      digitCount: 9,
      flag: '🇪🇸',
      format: '+34 XXX XXX XXX',
      example: '+34 612 345 678'
    },
    {
      countryCode: 'KR',
      countryName: 'South Korea',
      dialCode: '+82',
      digitCount: 10,
      flag: '🇰🇷',
      format: '+82 XX XXXX XXXX',
      example: '+82 10 1234 5678'
    },
    {
      countryCode: 'NL',
      countryName: 'Netherlands',
      dialCode: '+31',
      digitCount: 9,
      flag: '🇳🇱',
      format: '+31 X XXXX XXXX',
      example: '+31 6 1234 5678'
    },
    {
      countryCode: 'SE',
      countryName: 'Sweden',
      dialCode: '+46',
      digitCount: 9,
      flag: '🇸🇪',
      format: '+46 XX XXX XX XX',
      example: '+46 70 123 45 67'
    },
    {
      countryCode: 'CH',
      countryName: 'Switzerland',
      dialCode: '+41',
      digitCount: 9,
      flag: '🇨🇭',
      format: '+41 XX XXX XX XX',
      example: '+41 79 123 45 67'
    },
    {
      countryCode: 'BE',
      countryName: 'Belgium',
      dialCode: '+32',
      digitCount: 9,
      flag: '🇧🇪',
      format: '+32 XXX XX XX XX',
      example: '+32 470 12 34 56'
    },
    {
      countryCode: 'AT',
      countryName: 'Austria',
      dialCode: '+43',
      digitCount: 10,
      flag: '🇦🇹',
      format: '+43 XXX XXXXXXX',
      example: '+43 664 1234567'
    },
    {
      countryCode: 'NO',
      countryName: 'Norway',
      dialCode: '+47',
      digitCount: 8,
      flag: '🇳🇴',
      format: '+47 XXX XX XXX',
      example: '+47 412 34 567'
    },
    {
      countryCode: 'DK',
      countryName: 'Denmark',
      dialCode: '+45',
      digitCount: 8,
      flag: '🇩🇰',
      format: '+45 XX XX XX XX',
      example: '+45 20 12 34 56'
    },
    {
      countryCode: 'FI',
      countryName: 'Finland',
      dialCode: '+358',
      digitCount: 9,
      flag: '🇫🇮',
      format: '+358 XX XXX XXXX',
      example: '+358 50 123 4567'
    },
    {
      countryCode: 'PL',
      countryName: 'Poland',
      dialCode: '+48',
      digitCount: 9,
      flag: '🇵🇱',
      format: '+48 XXX XXX XXX',
      example: '+48 512 345 678'
    },
    {
      countryCode: 'TR',
      countryName: 'Turkey',
      dialCode: '+90',
      digitCount: 10,
      flag: '🇹🇷',
      format: '+90 XXX XXX XX XX',
      example: '+90 532 123 45 67'
    },
    {
      countryCode: 'AE',
      countryName: 'United Arab Emirates',
      dialCode: '+971',
      digitCount: 9,
      flag: '🇦🇪',
      format: '+971 XX XXX XXXX',
      example: '+971 50 123 4567'
    },
    {
      countryCode: 'SA',
      countryName: 'Saudi Arabia',
      dialCode: '+966',
      digitCount: 9,
      flag: '🇸🇦',
      format: '+966 XX XXX XXXX',
      example: '+966 50 123 4567'
    },
    {
      countryCode: 'SG',
      countryName: 'Singapore',
      dialCode: '+65',
      digitCount: 8,
      flag: '🇸🇬',
      format: '+65 XXXX XXXX',
      example: '+65 9123 4567'
    },
    {
      countryCode: 'MY',
      countryName: 'Malaysia',
      dialCode: '+60',
      digitCount: 9,
      flag: '🇲🇾',
      format: '+60 XX XXX XXXX',
      example: '+60 12 345 6789'
    },
    {
      countryCode: 'TH',
      countryName: 'Thailand',
      dialCode: '+66',
      digitCount: 9,
      flag: '🇹🇭',
      format: '+66 XX XXX XXXX',
      example: '+66 81 234 5678'
    },
    {
      countryCode: 'ID',
      countryName: 'Indonesia',
      dialCode: '+62',
      digitCount: 10,
      flag: '🇮🇩',
      format: '+62 XXX XXXX XXXX',
      example: '+62 812 3456 7890'
    },
    {
      countryCode: 'PH',
      countryName: 'Philippines',
      dialCode: '+63',
      digitCount: 10,
      flag: '🇵🇭',
      format: '+63 XXX XXX XXXX',
      example: '+63 917 123 4567'
    },
    {
      countryCode: 'VN',
      countryName: 'Vietnam',
      dialCode: '+84',
      digitCount: 9,
      flag: '🇻🇳',
      format: '+84 XX XXX XXXX',
      example: '+84 91 234 5678'
    },
    {
      countryCode: 'BD',
      countryName: 'Bangladesh',
      dialCode: '+880',
      digitCount: 10,
      flag: '🇧🇩',
      format: '+880 XXXX XXXXXX',
      example: '+880 1712 345678'
    },
    {
      countryCode: 'PK',
      countryName: 'Pakistan',
      dialCode: '+92',
      digitCount: 10,
      flag: '🇵🇰',
      format: '+92 XXX XXXXXXX',
      example: '+92 300 1234567'
    },
    {
      countryCode: 'LK',
      countryName: 'Sri Lanka',
      dialCode: '+94',
      digitCount: 9,
      flag: '🇱🇰',
      format: '+94 XX XXX XXXX',
      example: '+94 71 234 5678'
    },
    {
      countryCode: 'NP',
      countryName: 'Nepal',
      dialCode: '+977',
      digitCount: 10,
      flag: '🇳🇵',
      format: '+977 XXXX XXXXXX',
      example: '+977 9841 234567'
    },
    {
      countryCode: 'MM',
      countryName: 'Myanmar',
      dialCode: '+95',
      digitCount: 9,
      flag: '🇲🇲',
      format: '+95 XX XXX XXXX',
      example: '+95 91 234 5678'
    },
    {
      countryCode: 'ZA',
      countryName: 'South Africa',
      dialCode: '+27',
      digitCount: 9,
      flag: '🇿🇦',
      format: '+27 XX XXX XXXX',
      example: '+27 82 123 4567'
    },
    {
      countryCode: 'EG',
      countryName: 'Egypt',
      dialCode: '+20',
      digitCount: 10,
      flag: '🇪🇬',
      format: '+20 XXX XXX XXXX',
      example: '+20 100 123 4567'
    },
    {
      countryCode: 'NG',
      countryName: 'Nigeria',
      dialCode: '+234',
      digitCount: 10,
      flag: '🇳🇬',
      format: '+234 XXX XXX XXXX',
      example: '+234 802 123 4567'
    },
    {
      countryCode: 'KE',
      countryName: 'Kenya',
      dialCode: '+254',
      digitCount: 9,
      flag: '🇰🇪',
      format: '+254 XXX XXX XXX',
      example: '+254 712 345 678'
    },
    {
      countryCode: 'GH',
      countryName: 'Ghana',
      dialCode: '+233',
      digitCount: 9,
      flag: '🇬🇭',
      format: '+233 XX XXX XXXX',
      example: '+233 24 123 4567'
    },
    {
      countryCode: 'AR',
      countryName: 'Argentina',
      dialCode: '+54',
      digitCount: 10,
      flag: '🇦🇷',
      format: '+54 XX XXXX XXXX',
      example: '+54 11 1234 5678'
    },
    {
      countryCode: 'CL',
      countryName: 'Chile',
      dialCode: '+56',
      digitCount: 9,
      flag: '🇨🇱',
      format: '+56 X XXXX XXXX',
      example: '+56 9 1234 5678'
    },
    {
      countryCode: 'CO',
      countryName: 'Colombia',
      dialCode: '+57',
      digitCount: 10,
      flag: '🇨🇴',
      format: '+57 XXX XXX XXXX',
      example: '+57 300 123 4567'
    },
    {
      countryCode: 'PE',
      countryName: 'Peru',
      dialCode: '+51',
      digitCount: 9,
      flag: '🇵🇪',
      format: '+51 XXX XXX XXX',
      example: '+51 987 654 321'
    },
    {
      countryCode: 'VE',
      countryName: 'Venezuela',
      dialCode: '+58',
      digitCount: 10,
      flag: '🇻🇪',
      format: '+58 XXX XXX XXXX',
      example: '+58 412 123 4567'
    }
  ];

  static getCountryByCode(countryCode: string): CountryModel | undefined {
    return this.countries.find(country => country.countryCode === countryCode);
  }

  static getCountryByDialCode(dialCode: string): CountryModel | undefined {
    return this.countries.find(country => country.dialCode === dialCode);
  }

  static getCountryByName(countryName: string): CountryModel | undefined {
    return this.countries.find(country => 
      country.countryName.toLowerCase() === countryName.toLowerCase()
    );
  }

  static getDefaultCountry(): CountryModel {
    return this.countries[0]; // India as default
  }
}
